import { DataGrid, GridColDef, GridRowParams } from '@mui/x-data-grid';
import React, { useMemo } from 'react';
import { getOverviewDataGridProps } from 'v2/components/DataGrid/getOverviewDataGridProps';
import { renderHeaderWithId } from 'v2/components/DataGrid/renderHeaderWithId';
import NoRowsOverlay from 'v2/components/NoRowsOverlay/NoRowsOverlay';
import { TextCell } from 'v2/components/TextCell/TextCell';
import { DATAGRID_ROW_HEIGHT } from 'v2/constants';

interface Row {
  id: string;
  name: string;
}

interface Props {
  rows: Row[];
  headerName: string;
  loading: boolean;
  isHighlighted: (id: string) => boolean;
  onRowClick: (id: string) => void;
  idPrefix?: string;
  noRowsMessage?: string;
}

const SingleColumnDataGrid: React.FC<Props> = ({
  rows,
  headerName,
  loading,
  isHighlighted,
  onRowClick,
  idPrefix,
  noRowsMessage
}) => {
  const columns: GridColDef<Row>[] = useMemo(
    () => [
      {
        field: 'name',
        headerName,
        flex: 1,
        sortable: false,
        renderHeader: renderHeaderWithId(idPrefix),
        renderCell: ({ row }) => <TextCell variant="title">{row.name}</TextCell>
      }
    ],
    [headerName, idPrefix]
  );

  const overviewDataGridProps = getOverviewDataGridProps({ rowCount: rows.length, loading });

  return (
    <DataGrid
      {...overviewDataGridProps}
      className="background-level2"
      rows={rows}
      columns={columns}
      rowHeight={DATAGRID_ROW_HEIGHT}
      getRowClassName={(params) => (isHighlighted(params.row.id) ? 'row-highlighted' : '')}
      onRowClick={(params: GridRowParams<Row>) => onRowClick(params.row.id)}
      slots={{
        ...overviewDataGridProps.slots,
        noRowsOverlay: NoRowsOverlay
      }}
      slotProps={{
        ...overviewDataGridProps.slotProps,
        row: { idPrefix },
        cell: { idPrefix },
        noRowsOverlay: { message: noRowsMessage }
      }}
    />
  );
};

export default SingleColumnDataGrid;
